// University of Maryland, College Park undergraduate majors (#2840). Read
// on 2026-10-01 from the official 2026-2027 Undergraduate Catalog's
// Undergraduate Programs page (academiccatalog.umd.edu/undergraduate/
// programs/, "Majors" list), each major filed under the college or school
// its catalog link sits in. The majors offered at the Universities at Shady
// Grove or USM Southern Maryland (separate listings, some of the same
// majors) are left out, as are minors and certificates. The list does not
// state degrees, so `degree` is null except for Chemistry, whose listing
// names its B.A. and B.S. The word "Major" is dropped from each name; the
// department tags (BSOS, CMNS, ARTT, CMSC, INFO) are dropped where the
// group already tells the two apart, and the two Cinema and Media Studies
// majors in Arts and Humanities keep their department (English; Languages,
// Literatures, and Cultures). "Secondary Education Major - Art" and its
// siblings are written "Secondary Education (Art)". The official name
// "Artificial Intelligence: Computational Structures for AI Systems" is
// kept as written. The KB's majors list was the starting point; the
// catalog wins.
const majors = {
    "slug": "university-of-maryland-college-park",
    "read": "2026-10-01",
    "intro": "Every undergraduate major in UMD's official 2026-2027 Undergraduate Catalog for the College Park campus, grouped by the college or school that offers it. Minors, certificates, majors offered only at Shady Grove or Southern Maryland, and graduate programs are left out.",
    "groups": [
        {
            "name": "A. James Clark School of Engineering",
            "source": {
                "label": "UMD Undergraduate Catalog 2026-2027, A. James Clark School of Engineering",
                "url": "https://academiccatalog.umd.edu/undergraduate/colleges-schools/engineering/"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": null
                },
                {
                    "name": "Biocomputational Engineering",
                    "degree": null
                },
                {
                    "name": "Bioengineering",
                    "degree": null
                },
                {
                    "name": "Chemical Engineering",
                    "degree": null
                },
                {
                    "name": "Civil Engineering",
                    "degree": null
                },
                {
                    "name": "Computer Engineering",
                    "degree": null
                },
                {
                    "name": "Cyber-Physical Systems Engineering",
                    "degree": null
                },
                {
                    "name": "Electrical Engineering",
                    "degree": null
                },
                {
                    "name": "Fire Protection Engineering",
                    "degree": null
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": null
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": null
                },
                {
                    "name": "Mechatronics Engineering",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Agriculture and Natural Resources",
            "source": {
                "label": "UMD Undergraduate Catalog 2026-2027, College of Agriculture and Natural Resources",
                "url": "https://academiccatalog.umd.edu/undergraduate/colleges-schools/agriculture-natural-resources/"
            },
            "majors": [
                {
                    "name": "Agricultural Science and Technology",
                    "degree": null
                },
                {
                    "name": "Agricultural and Resource Economics",
                    "degree": null
                },
                {
                    "name": "Animal Sciences",
                    "degree": null
                },
                {
                    "name": "Environmental Science and Policy",
                    "degree": null
                },
                {
                    "name": "Environmental Science and Technology",
                    "degree": null
                },
                {
                    "name": "Fermentation Science",
                    "degree": null
                },
                {
                    "name": "Landscape Architecture",
                    "degree": null
                },
                {
                    "name": "Nutrition and Food Science",
                    "degree": null
                },
                {
                    "name": "Plant Sciences",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Arts and Humanities",
            "source": {
                "label": "UMD Undergraduate Catalog 2026-2027, College of Arts and Humanities",
                "url": "https://academiccatalog.umd.edu/undergraduate/colleges-schools/arts-humanities/"
            },
            "majors": [
                {
                    "name": "American Studies",
                    "degree": null
                },
                {
                    "name": "Arabic Studies",
                    "degree": null
                },
                {
                    "name": "Art History",
                    "degree": null
                },
                {
                    "name": "Chinese",
                    "degree": null
                },
                {
                    "name": "Cinema and Media Studies (English)",
                    "degree": null
                },
                {
                    "name": "Cinema and Media Studies (Languages, Literatures, and Cultures)",
                    "degree": null
                },
                {
                    "name": "Classical Languages and Literatures",
                    "degree": null
                },
                {
                    "name": "Communication",
                    "degree": null
                },
                {
                    "name": "Dance",
                    "degree": null
                },
                {
                    "name": "English Language and Literature",
                    "degree": null
                },
                {
                    "name": "French Language and Literature",
                    "degree": null
                },
                {
                    "name": "German Studies",
                    "degree": null
                },
                {
                    "name": "Global Culture and Thought",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "Human-Centered Artificial Intelligence",
                    "degree": null
                },
                {
                    "name": "Immersive Media Design",
                    "degree": null
                },
                {
                    "name": "Italian Studies",
                    "degree": null
                },
                {
                    "name": "Japanese",
                    "degree": null
                },
                {
                    "name": "Jewish Studies",
                    "degree": null
                },
                {
                    "name": "Linguistics",
                    "degree": null
                },
                {
                    "name": "Music",
                    "degree": null
                },
                {
                    "name": "Persian Studies",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Philosophy, Politics, and Economics",
                    "degree": null
                },
                {
                    "name": "Religions of the Ancient Middle East",
                    "degree": null
                },
                {
                    "name": "Romance Languages",
                    "degree": null
                },
                {
                    "name": "Russian Language and Literature",
                    "degree": null
                },
                {
                    "name": "Spanish Language, Literatures, and Culture",
                    "degree": null
                },
                {
                    "name": "Studio Art",
                    "degree": null
                },
                {
                    "name": "Theatre",
                    "degree": null
                },
                {
                    "name": "Women, Gender, and Sexuality Studies",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Behavioral and Social Sciences",
            "source": {
                "label": "UMD Undergraduate Catalog 2026-2027, College of Behavioral and Social Sciences",
                "url": "https://academiccatalog.umd.edu/undergraduate/colleges-schools/behavioral-social-sciences/"
            },
            "majors": [
                {
                    "name": "African American and Africana Studies",
                    "degree": null
                },
                {
                    "name": "Anthropology",
                    "degree": null
                },
                {
                    "name": "Criminology and Criminal Justice",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "Geographical Sciences",
                    "degree": null
                },
                {
                    "name": "Government and Politics",
                    "degree": null
                },
                {
                    "name": "Hearing and Speech Sciences",
                    "degree": null
                },
                {
                    "name": "International Relations",
                    "degree": null
                },
                {
                    "name": "Neuroscience",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Social Data Science",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Computer, Mathematical, and Natural Sciences",
            "source": {
                "label": "UMD Undergraduate Catalog 2026-2027, College of Computer, Mathematical, and Natural Sciences",
                "url": "https://academiccatalog.umd.edu/undergraduate/colleges-schools/computer-mathematical-natural-sciences/"
            },
            "majors": [
                {
                    "name": "Artificial Intelligence: Computational Structures for AI Systems",
                    "degree": null
                },
                {
                    "name": "Astronomy",
                    "degree": null
                },
                {
                    "name": "Atmospheric and Oceanic Science",
                    "degree": null
                },
                {
                    "name": "Biochemistry",
                    "degree": null
                },
                {
                    "name": "Biological Sciences",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Geology",
                    "degree": null
                },
                {
                    "name": "Immersive Media Design",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Neuroscience",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "UMD Undergraduate Catalog 2026-2027, College of Education",
                "url": "https://academiccatalog.umd.edu/undergraduate/colleges-schools/education/"
            },
            "majors": [
                {
                    "name": "Early Childhood/Early Childhood Special Education",
                    "degree": null
                },
                {
                    "name": "Elementary Education",
                    "degree": null
                },
                {
                    "name": "Elementary/Middle Special Education",
                    "degree": null
                },
                {
                    "name": "Human Development",
                    "degree": null
                },
                {
                    "name": "Middle School Education",
                    "degree": null
                },
                {
                    "name": "Secondary Education (Art)",
                    "degree": null
                },
                {
                    "name": "Secondary Education (English)",
                    "degree": null
                },
                {
                    "name": "Secondary Education (Mathematics)",
                    "degree": null
                },
                {
                    "name": "Secondary Education (Science)",
                    "degree": null
                },
                {
                    "name": "Secondary Education (Social Studies)",
                    "degree": null
                },
                {
                    "name": "Secondary Education (World Language)",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Information",
            "source": {
                "label": "UMD Undergraduate Catalog 2026-2027, College of Information",
                "url": "https://academiccatalog.umd.edu/undergraduate/colleges-schools/information/"
            },
            "majors": [
                {
                    "name": "Information Science",
                    "degree": null
                },
                {
                    "name": "Social Data Science",
                    "degree": null
                },
                {
                    "name": "Technology and Information Design",
                    "degree": null
                }
            ]
        },
        {
            "name": "Office of Undergraduate Studies",
            "source": {
                "label": "UMD Undergraduate Catalog 2026-2027, Office of Undergraduate Studies",
                "url": "https://academiccatalog.umd.edu/undergraduate/colleges-schools/undergraduate-studies/"
            },
            "majors": [
                {
                    "name": "Individual Studies Program",
                    "degree": null
                }
            ]
        },
        {
            "name": "Philip Merrill College of Journalism",
            "source": {
                "label": "UMD Undergraduate Catalog 2026-2027, Philip Merrill College of Journalism",
                "url": "https://academiccatalog.umd.edu/undergraduate/colleges-schools/journalism/"
            },
            "majors": [
                {
                    "name": "Journalism",
                    "degree": null
                }
            ]
        },
        {
            "name": "Robert H. Smith School of Business",
            "source": {
                "label": "UMD Undergraduate Catalog 2026-2027, Robert H. Smith School of Business",
                "url": "https://academiccatalog.umd.edu/undergraduate/colleges-schools/business/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": null
                },
                {
                    "name": "Finance",
                    "degree": null
                },
                {
                    "name": "Information Systems",
                    "degree": null
                },
                {
                    "name": "International Business",
                    "degree": null
                },
                {
                    "name": "Management",
                    "degree": null
                },
                {
                    "name": "Marketing",
                    "degree": null
                },
                {
                    "name": "Operations Management & Business Analytics",
                    "degree": null
                },
                {
                    "name": "Supply Chain Management",
                    "degree": null
                }
            ]
        },
        {
            "name": "School of Architecture, Planning and Preservation",
            "source": {
                "label": "UMD Undergraduate Catalog 2026-2027, School of Architecture, Planning and Preservation",
                "url": "https://academiccatalog.umd.edu/undergraduate/colleges-schools/architecture-planning-preservation/"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": null
                },
                {
                    "name": "Real Estate and the Built Environment",
                    "degree": null
                }
            ]
        },
        {
            "name": "School of Public Health",
            "source": {
                "label": "UMD Undergraduate Catalog 2026-2027, School of Public Health",
                "url": "https://academiccatalog.umd.edu/undergraduate/colleges-schools/public-health/"
            },
            "majors": [
                {
                    "name": "Family Health",
                    "degree": null
                },
                {
                    "name": "Global Health",
                    "degree": null
                },
                {
                    "name": "Kinesiology",
                    "degree": null
                },
                {
                    "name": "Public Health Practice",
                    "degree": null
                },
                {
                    "name": "Public Health Science",
                    "degree": null
                }
            ]
        },
        {
            "name": "School of Public Policy",
            "source": {
                "label": "UMD Undergraduate Catalog 2026-2027, School of Public Policy",
                "url": "https://academiccatalog.umd.edu/undergraduate/colleges-schools/public-policy/"
            },
            "majors": [
                {
                    "name": "Global and Foreign Policy",
                    "degree": null
                },
                {
                    "name": "Public Policy",
                    "degree": null
                }
            ]
        }
    ]
};

export default majors;
